// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__HSmYe","heading":"AboutUs_heading__HllD6","text":"AboutUs_text__Z6Nvm"};